<template>
 
    <v-layout row class="text-xs-center" style="height:100%">
      <v-flex xs7 class="left_login_back">
      </v-flex>
      <v-flex xs5 class="grey lighten-4">
        <v-container style="position: relative;top: 13%;" class="text-xs-center">
                <v-avatar size="200">
                        <img src="../../../public/images/pharma_logo.jpg" alt="">
                </v-avatar>

                 <v-form
      ref="form"
      lazy-validation
    >
      <v-text-field
        v-model="username"
        label="User Name"
        required
      ></v-text-field>
  
      <v-text-field
        v-model="password"
        label="Password"
        required
        :append-icon="show1 ? 'visibility' : 'visibility_off'"
        :type="show1 ? 'text' : 'password'"
        counter
        @click:append="show1 = !show1"
      ></v-text-field>
<!--   
      <v-select
        v-model="select"
        :items="items"
        label="Branch"
        disabled

      ></v-select> -->
  
      <!-- <v-checkbox
        v-model="checkbox"
        :rules="[v => !!v || 'You must agree to continue!']"
        label="Remember Password?"
        required
      ></v-checkbox> -->
  
      <v-btn
        color="success"
        @click="login"
      >
        تسجيل دخول 
      </v-btn>
  
      <!-- <v-btn
        color="error"
        @click="reset"
      >
        Reset Form
      </v-btn> -->
  
    </v-form>
        </v-container>
      </v-flex>
    </v-layout>

</template>

<script>
import {login_client} from '../config/apiRoute.js'
export default {
        data(){
                return{
                        items: [
                        'cairo',
                        'Alex',
                        'Assuit',
                        'Giza'
                        ],

                        username:'',
                        password:'',
                        show1:false,
                }             
},
methods:{
  login(){
    var frmData = new FormData();
    frmData.append('username',this.username) 
    frmData.append('password',this.password) 
    login_client(frmData).then((response)=>{
        let token=response.data.data.token
        let user=response.data.data.userData
        // let permission=response.data.data.permission

        //   if ( user.type == '1' || user.type == 1) {
        //    localStorage.setItem('token',JSON.stringify(token))
        // localStorage.setItem('user',JSON.stringify(user))
        // localStorage.setItem('permission',JSON.stringify(permission))
        // localStorage.setItem('userAuth', JSON.stringify(true));
        //   this.$router.push('/')
        //   }
        // if ((user.type == '0' || user.type == '1' || user.type == 0 || user.type == 1 ) && user.employer.job_id != 1 && user.employer.job_id != 2 && user.employer.job_id != 3 && user.employer.job_id != 4 && user.employer.job_id != 12 && user.employer.job_id != 13 && user.employer.job_id != 14 && user.employer.job_id != 15 && user.employer.job_id != 16  ) {
        // localStorage.setItem('token',JSON.stringify(token))
        // localStorage.setItem('user',JSON.stringify(user))
        // localStorage.setItem('permission',JSON.stringify(permission))
        // localStorage.setItem('userAuth', JSON.stringify(true));
        //   this.$router.push('/')
        // }
    })
  },
  reset(){
   
  },
}
}
</script>
<style scoped>
  .left_login_back{
          background: url('../../../public/images/back.jpg') center center no-repeat;
         
  }      
</style>